import { NgModule } from '@angular/core';
import { META_REDUCERS, StoreModule } from '@ngrx/store';
import { ConfigModule, ProcessModule, StateConfig, StateTransferType } from '@spartacus/core';
import { CATALOG_FEATURE } from './catalog-state';
import { loadMoreProductsFactory, loadProductsByCodesFactory, reducerProvider, reducerToken } from './reducers';

function catalogStoreConfigFactory(): StateConfig {
  // if we want to reuse CATALOG_FEATURE const in config, we have to use factory instead of plain object
  return {
    state: {
      ssrTransfer: {
        keys: {
          [CATALOG_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    ProcessModule.forRoot(),
    StoreModule.forFeature(CATALOG_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(catalogStoreConfigFactory),
  ],
  providers: [
    reducerProvider,
    {
      provide: META_REDUCERS,
      useFactory: loadProductsByCodesFactory,
      multi: true,
    },
    {
      provide: META_REDUCERS,
      useFactory: loadMoreProductsFactory,
      multi: true,
    },
  ],
})
export class CatalogStoreModule {}
